module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch08"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch08"
    }
  }, [_c('b', [_vm._v("Ancient Eating")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In ancient Rome, it was considered a sin to eat a woodpecker.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first volume of published recipes dates to AD 62. Titled "), _c('i', [_vm._v("De re coquinaria")]), _vm._v(" (“On the Subject of Cooking”), it described the feasts enjoyed by the Roman emperor Claudius.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first archaeological evidence of soup dates back to 6000 BC. The main ingredient was hippopotamus.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Romans did not eat sitting up—that was considered extremely bad manners. They ate lying down on couches around the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The oldest known sample of a chewing gum was found in Sweden in 1993. The 9,000-year-old gob of honey-sweetened resin still contained tooth marks.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In the 13th century, quality standards for pasta were set by the pope.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Romans flavored food with garum, a paste made by leaving fish to rot for several weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Pepper was so valuable during Elizabethan times that it was sold by the individual grain.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The ancient Romans had soft drinks of root juices and water.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba09d7e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter08.vue
// module id = 96
// module chunks = 0